import Page from "../webPage/Page";
import Questionnaire from "../Questionnaire";

Page.register('/apprenticeships/apprentices/questionnaire/', () => {

    new Questionnaire($('.js-questionnaire'));

});